import { Data } from './data';
import { Token } from './token';
import { Partenaire } from './~partenaire';

export class User extends Data {

    username: string;
    name: string;
    // roles: string[];
    role: string;
    email: string;
    password: string;
    // tslint:disable-next-line:variable-name
    is_active: boolean;
    // tslint:disable-next-line:variable-name
    recent_token: Token;

    parrain;
    tel: string;
    pays: string;
    ville: string;
    adresse: string;
    bp: string;
    civility: string;
    newpassword: string;
    is_storespace: boolean;
    storename: string;
    fils: User[];
    solde_transaction;
    total_commission;
    total_gain;
    total_vente;
    nbr_prod;
    total_nbr_vente;
    nbr_fils;

    constructor() {
        super(); // on appelle le constructeur du parent;
        this.is_active = false;
    }

    get etat(): string{
        if (this.is_active === true)
        return 'Activé';
        else
        return 'Désactivé';
    }

    get recentConnexion(): string {
        if (this.recent_token !== null && this.recent_token !== undefined)
        return this.formatDate(this.recent_token.created_at);
        else
        return null;
    }



}
